var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "recorder", class: { active: _vm.isPilotRecording } },
      [
        _c(
          "button",
          {
            staticClass: "recorder-button",
            class: { active: _vm.isPilotRecording },
            attrs: { role: "button" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.onRecorderButtonClicked.apply(null, arguments)
              },
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t(_vm.recorderButtonText) + _vm.remainTimeStr) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _vm.remainTimeWarningActive
          ? _c("div", { staticClass: "remainTimeWarning" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pilotRecorderRemainTimeWarning")) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c("audio", {
      staticClass: "video-js vjs-default-skin display-none",
      attrs: { id: "myVideo", playsinline: "" },
    }),
    _vm._v(" "),
    _vm.recorderPopupActive
      ? _c("div", { staticClass: "recorder-popup" }, [
          _c("div", { staticClass: "recorder-popup-inner" }, [
            _c("div", { staticClass: "recorder-popup-title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t(_vm.recorderPopupTitle)) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "recorder-popup-text",
              class: { "is-notice": !_vm.deviceInitialized },
              domProps: { innerHTML: _vm._s(_vm.$t(_vm.recorderPopupText)) },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close-window-button",
                attrs: { role: "button" },
                on: { click: _vm.closeRecorderPopup },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("pilotRecorderPopupButtonOK")) +
                    "\n      "
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }